import { render } from "./Loading.vue?vue&type=template&id=19c08bed&scoped=true"
import script from "./Loading.vue?vue&type=script&lang=ts"
export * from "./Loading.vue?vue&type=script&lang=ts"

import "./Loading.vue?vue&type=style&index=0&id=19c08bed&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-19c08bed"

export default script